import Axios from 'axios'

class BaseService {
  constructor() {
    this.ignoreErrHandler = ['/assets/version.txt']
  }

  start() {
    this.startRequest()
    this.startResponse()
  }

  startRequest() {
    Axios.interceptors.request.use(
      (request) => {
        request.withCredentials = true

        request.headers['Content-Type'] = 'application/json;charset=UTF-8'
        request.headers['Authorization'] = localStorage.getItem('auth_cadu')

        return request
      },
      (err) => {
        return Promise.reject(err)
      }
    )
  }

  startResponse() {
    Axios.interceptors.response.use(
      (response) => {
        if (response.headers['x-authorization-new']) {
          localStorage.setItem('auth_cadu', response.headers['x-authorization-new'])
        }

        return response
      },
      (err) => {
        return Promise.reject(err)
      }
    )
  }
}

export default new BaseService()
